import {navigationSlice} from './slice';

export * from './slice';
export * from './selectors';
export default navigationSlice.reducer;
